module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAFVBMVEUAAAD///9CQkJCQkJCQkJCQkJCQkJxi7Q8AAAABnRSTlMAADNEd7vHZvD3AAAALklEQVQY02NgwABmCQyMgoICdOMwGwOBWzKIVGBgS4ODAFTOgLgNDFQDkDhQAADYvRnTMiqM6wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./ngapp/images/groups/group_icon_toolbar_request.png
// module id = 802
// module chunks = 0